import xhr from 'xhr'
import api from './api'
import carSlider from './carSlider'

class campaignFormSwitcher {

    initialize() {
        let formSwitcherValue = null
        const formSwitcher = document.querySelectorAll('.select-activity input[type="radio"]')

        if(formSwitcher) {

            // get default value
            for (let i = 0, length = formSwitcher.length; i < length; i++) {
                if (formSwitcher[i].checked) {
                    formSwitcherValue = formSwitcher[i].value
                    break
                }
            }
            document.querySelector("main").dataset.context = formSwitcherValue

            // attach event for context change
            formSwitcher.forEach(item => {
               item.addEventListener('change', e => {
                   const context = e.currentTarget
                   const vehicule_id = document.querySelector("main").getAttribute("data-id")
                   const isFixedCar = document.querySelector("main").getAttribute("data-fixed-car")
                   var isCustomConfig = document.getElementById('configId') ? document.getElementById('configId').value : null;
                   if (!isCustomConfig) {
                       // used by RFO-SL
                       isCustomConfig = document.getElementById('vehicleModelOptions') ? document.getElementById('vehicleModelOptions').value : null;
                   }
                   if(context.value === 'b2b') {
                       if(document.getElementById('raison-sociale')) {
                           document.getElementById('raison-sociale').required = true
                           document.getElementById('raison-sociale').classList.add('required')
                       }
                   } else {
                       if(document.getElementById('raison-sociale')) {
                           document.getElementById('raison-sociale').required = false
                           document.getElementById('raison-sociale').classList.remove('required')
                       }
                   }
                   if (!isCustomConfig && !isFixedCar) {
                       // load new vehicle by context
                       this.switchVehicule(vehicule_id, context.value);
                   }
                   document.querySelector("main").dataset.context = context.value
               })
            })
        }

        const formSwitcherVersionB = document.querySelectorAll('.is-professional');

        if(formSwitcherVersionB) {

            formSwitcherVersionB.forEach(item => {
                item.addEventListener('change', e => {
                    const context = e.currentTarget
                    if (context.checked)
                    {
                        document.getElementById('professional').click();
                    }
                    else
                    {
                        document.getElementById('private').click();
                    }
                })
            });
        }
    }


    switchVehicule(id, context) {

        let url = api().bmw + vehiculeSwitcherUrl.replace(api().appPrefix, '') + '/' + id + '/' + context

        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.has('black'))
        {
            const black = urlParams.get('black')
            url = api().bmw + vehiculeSwitcherUrl.replace(api().appPrefix, '') + '/' + id + '/' + context +"?black=" + black
        }
        else if (urlParams.has('version'))
        {
            const version = urlParams.get('version')
            url = api().bmw + vehiculeSwitcherUrl.replace(api().appPrefix, '') + '/' + id + '/' + context +"?version=" + version


            if (urlParams.has('black'))
            {
                url = url + "&black=" + urlParams.get('black')
            }
        }
        var mainFormVersion = document.querySelector('main[data-form-version]');
        if(mainFormVersion) {
            url += '?fv=' + mainFormVersion.dataset.formVersion;
        }

        xhr(
            {
                method: "GET",
                uri: url
            },
            (err, resp, body) => {
                let data = JSON.parse(body)
                if(data.car) {
                    if(document.getElementById('form-vehicule-block')) {
                        document.getElementById('form-vehicule-block').outerHTML = data.vehiculeBlock
                    }
                    if(document.getElementById('form-vehicule-pricing') && data.pricingBlock != "") {
                        document.getElementById('form-vehicule-pricing').outerHTML = data.pricingBlock
                    }
                    if(document.getElementById('carLegalNoticeText')) {
                        document.getElementById('carLegalNoticeText').innerHTML = data.legalnotice
                    }
                    document.querySelector("main").dataset.id = data.car
                    carSlider('.thumbnail-car__image')
                }
            }
        )

    }

}
export default campaignFormSwitcher



